var map = {
	"./": 12,
	"./_lib/buildFormatLongFn": 11,
	"./_lib/buildFormatLongFn/": 11,
	"./_lib/buildFormatLongFn/index": 11,
	"./_lib/buildFormatLongFn/index.js": 11,
	"./_lib/buildLocalizeFn": 13,
	"./_lib/buildLocalizeFn/": 13,
	"./_lib/buildLocalizeFn/index": 13,
	"./_lib/buildLocalizeFn/index.js": 13,
	"./_lib/buildMatchFn": 14,
	"./_lib/buildMatchFn/": 14,
	"./_lib/buildMatchFn/index": 14,
	"./_lib/buildMatchFn/index.js": 14,
	"./_lib/buildMatchPatternFn": 15,
	"./_lib/buildMatchPatternFn/": 15,
	"./_lib/buildMatchPatternFn/index": 15,
	"./_lib/buildMatchPatternFn/index.js": 15,
	"./af": 482,
	"./af/": 482,
	"./af/_lib/formatDistance": 159,
	"./af/_lib/formatDistance/": 159,
	"./af/_lib/formatDistance/index": 159,
	"./af/_lib/formatDistance/index.js": 159,
	"./af/_lib/formatLong": 160,
	"./af/_lib/formatLong/": 160,
	"./af/_lib/formatLong/index": 160,
	"./af/_lib/formatLong/index.js": 160,
	"./af/_lib/formatRelative": 161,
	"./af/_lib/formatRelative/": 161,
	"./af/_lib/formatRelative/index": 161,
	"./af/_lib/formatRelative/index.js": 161,
	"./af/_lib/localize": 162,
	"./af/_lib/localize/": 162,
	"./af/_lib/localize/index": 162,
	"./af/_lib/localize/index.js": 162,
	"./af/_lib/match": 163,
	"./af/_lib/match/": 163,
	"./af/_lib/match/index": 163,
	"./af/_lib/match/index.js": 163,
	"./af/index": 636,
	"./af/index.d.ts": 1165,
	"./af/index.js": 636,
	"./af/index.js.flow": 1166,
	"./af/package": 818,
	"./af/package.json": 818,
	"./af/snapshot.md": 1167,
	"./ar-DZ": 483,
	"./ar-DZ/": 483,
	"./ar-DZ/_lib/formatDistance": 164,
	"./ar-DZ/_lib/formatDistance/": 164,
	"./ar-DZ/_lib/formatDistance/index": 164,
	"./ar-DZ/_lib/formatDistance/index.js": 164,
	"./ar-DZ/_lib/formatLong": 165,
	"./ar-DZ/_lib/formatLong/": 165,
	"./ar-DZ/_lib/formatLong/index": 165,
	"./ar-DZ/_lib/formatLong/index.js": 165,
	"./ar-DZ/_lib/formatRelative": 166,
	"./ar-DZ/_lib/formatRelative/": 166,
	"./ar-DZ/_lib/formatRelative/index": 166,
	"./ar-DZ/_lib/formatRelative/index.js": 166,
	"./ar-DZ/_lib/localize": 167,
	"./ar-DZ/_lib/localize/": 167,
	"./ar-DZ/_lib/localize/index": 167,
	"./ar-DZ/_lib/localize/index.js": 167,
	"./ar-DZ/_lib/match": 168,
	"./ar-DZ/_lib/match/": 168,
	"./ar-DZ/_lib/match/index": 168,
	"./ar-DZ/_lib/match/index.js": 168,
	"./ar-DZ/index": 637,
	"./ar-DZ/index.d.ts": 1168,
	"./ar-DZ/index.js": 637,
	"./ar-DZ/index.js.flow": 1169,
	"./ar-DZ/package": 819,
	"./ar-DZ/package.json": 819,
	"./ar-DZ/snapshot.md": 1170,
	"./ar-MA": 484,
	"./ar-MA/": 484,
	"./ar-MA/_lib/formatDistance": 169,
	"./ar-MA/_lib/formatDistance/": 169,
	"./ar-MA/_lib/formatDistance/index": 169,
	"./ar-MA/_lib/formatDistance/index.js": 169,
	"./ar-MA/_lib/formatLong": 170,
	"./ar-MA/_lib/formatLong/": 170,
	"./ar-MA/_lib/formatLong/index": 170,
	"./ar-MA/_lib/formatLong/index.js": 170,
	"./ar-MA/_lib/formatRelative": 171,
	"./ar-MA/_lib/formatRelative/": 171,
	"./ar-MA/_lib/formatRelative/index": 171,
	"./ar-MA/_lib/formatRelative/index.js": 171,
	"./ar-MA/_lib/localize": 172,
	"./ar-MA/_lib/localize/": 172,
	"./ar-MA/_lib/localize/index": 172,
	"./ar-MA/_lib/localize/index.js": 172,
	"./ar-MA/_lib/match": 173,
	"./ar-MA/_lib/match/": 173,
	"./ar-MA/_lib/match/index": 173,
	"./ar-MA/_lib/match/index.js": 173,
	"./ar-MA/index": 638,
	"./ar-MA/index.d.ts": 1171,
	"./ar-MA/index.js": 638,
	"./ar-MA/index.js.flow": 1172,
	"./ar-MA/package": 820,
	"./ar-MA/package.json": 820,
	"./ar-MA/snapshot.md": 1173,
	"./ar-SA": 54,
	"./ar-SA/": 54,
	"./ar-SA/_lib/formatDistance": 174,
	"./ar-SA/_lib/formatDistance/": 174,
	"./ar-SA/_lib/formatDistance/index": 174,
	"./ar-SA/_lib/formatDistance/index.js": 174,
	"./ar-SA/_lib/formatLong": 175,
	"./ar-SA/_lib/formatLong/": 175,
	"./ar-SA/_lib/formatLong/index": 175,
	"./ar-SA/_lib/formatLong/index.js": 175,
	"./ar-SA/_lib/formatRelative": 176,
	"./ar-SA/_lib/formatRelative/": 176,
	"./ar-SA/_lib/formatRelative/index": 176,
	"./ar-SA/_lib/formatRelative/index.js": 176,
	"./ar-SA/_lib/localize": 177,
	"./ar-SA/_lib/localize/": 177,
	"./ar-SA/_lib/localize/index": 177,
	"./ar-SA/_lib/localize/index.js": 177,
	"./ar-SA/_lib/match": 178,
	"./ar-SA/_lib/match/": 178,
	"./ar-SA/_lib/match/index": 178,
	"./ar-SA/_lib/match/index.js": 178,
	"./ar-SA/index": 639,
	"./ar-SA/index.d.ts": 1174,
	"./ar-SA/index.js": 639,
	"./ar-SA/index.js.flow": 1175,
	"./ar-SA/package": 821,
	"./ar-SA/package.json": 821,
	"./ar-SA/snapshot.md": 1176,
	"./az": 485,
	"./az/": 485,
	"./az/_lib/formatDistance": 179,
	"./az/_lib/formatDistance/": 179,
	"./az/_lib/formatDistance/index": 179,
	"./az/_lib/formatDistance/index.js": 179,
	"./az/_lib/formatLong": 180,
	"./az/_lib/formatLong/": 180,
	"./az/_lib/formatLong/index": 180,
	"./az/_lib/formatLong/index.js": 180,
	"./az/_lib/formatRelative": 181,
	"./az/_lib/formatRelative/": 181,
	"./az/_lib/formatRelative/index": 181,
	"./az/_lib/formatRelative/index.js": 181,
	"./az/_lib/localize": 182,
	"./az/_lib/localize/": 182,
	"./az/_lib/localize/index": 182,
	"./az/_lib/localize/index.js": 182,
	"./az/_lib/match": 183,
	"./az/_lib/match/": 183,
	"./az/_lib/match/index": 183,
	"./az/_lib/match/index.js": 183,
	"./az/index": 640,
	"./az/index.d.ts": 1177,
	"./az/index.js": 640,
	"./az/index.js.flow": 1178,
	"./az/package": 822,
	"./az/package.json": 822,
	"./az/snapshot.md": 1179,
	"./be": 486,
	"./be/": 486,
	"./be/_lib/formatDistance": 184,
	"./be/_lib/formatDistance/": 184,
	"./be/_lib/formatDistance/index": 184,
	"./be/_lib/formatDistance/index.js": 184,
	"./be/_lib/formatLong": 185,
	"./be/_lib/formatLong/": 185,
	"./be/_lib/formatLong/index": 185,
	"./be/_lib/formatLong/index.js": 185,
	"./be/_lib/formatRelative": 186,
	"./be/_lib/formatRelative/": 186,
	"./be/_lib/formatRelative/index": 186,
	"./be/_lib/formatRelative/index.js": 186,
	"./be/_lib/localize": 187,
	"./be/_lib/localize/": 187,
	"./be/_lib/localize/index": 187,
	"./be/_lib/localize/index.js": 187,
	"./be/_lib/match": 188,
	"./be/_lib/match/": 188,
	"./be/_lib/match/index": 188,
	"./be/_lib/match/index.js": 188,
	"./be/index": 642,
	"./be/index.d.ts": 1183,
	"./be/index.js": 642,
	"./be/index.js.flow": 1184,
	"./be/package": 823,
	"./be/package.json": 823,
	"./be/snapshot.md": 1185,
	"./bg": 487,
	"./bg/": 487,
	"./bg/_lib/formatDistance": 189,
	"./bg/_lib/formatDistance/": 189,
	"./bg/_lib/formatDistance/index": 189,
	"./bg/_lib/formatDistance/index.js": 189,
	"./bg/_lib/formatLong": 190,
	"./bg/_lib/formatLong/": 190,
	"./bg/_lib/formatLong/index": 190,
	"./bg/_lib/formatLong/index.js": 190,
	"./bg/_lib/formatRelative": 191,
	"./bg/_lib/formatRelative/": 191,
	"./bg/_lib/formatRelative/index": 191,
	"./bg/_lib/formatRelative/index.js": 191,
	"./bg/_lib/localize": 192,
	"./bg/_lib/localize/": 192,
	"./bg/_lib/localize/index": 192,
	"./bg/_lib/localize/index.js": 192,
	"./bg/_lib/match": 193,
	"./bg/_lib/match/": 193,
	"./bg/_lib/match/index": 193,
	"./bg/_lib/match/index.js": 193,
	"./bg/index": 643,
	"./bg/index.d.ts": 1186,
	"./bg/index.js": 643,
	"./bg/index.js.flow": 1187,
	"./bg/package": 824,
	"./bg/package.json": 824,
	"./bg/snapshot.md": 1188,
	"./bn": 119,
	"./bn/": 119,
	"./bn/_lib/formatDistance": 194,
	"./bn/_lib/formatDistance/": 194,
	"./bn/_lib/formatDistance/index": 194,
	"./bn/_lib/formatDistance/index.js": 194,
	"./bn/_lib/formatLong": 195,
	"./bn/_lib/formatLong/": 195,
	"./bn/_lib/formatLong/index": 195,
	"./bn/_lib/formatLong/index.js": 195,
	"./bn/_lib/formatRelative": 196,
	"./bn/_lib/formatRelative/": 196,
	"./bn/_lib/formatRelative/index": 196,
	"./bn/_lib/formatRelative/index.js": 196,
	"./bn/_lib/localize": 110,
	"./bn/_lib/localize/": 110,
	"./bn/_lib/localize/index": 110,
	"./bn/_lib/localize/index.js": 110,
	"./bn/_lib/match": 197,
	"./bn/_lib/match/": 197,
	"./bn/_lib/match/index": 197,
	"./bn/_lib/match/index.js": 197,
	"./bn/index": 644,
	"./bn/index.d.ts": 1189,
	"./bn/index.js": 644,
	"./bn/index.js.flow": 1190,
	"./bn/package": 825,
	"./bn/package.json": 825,
	"./bn/snapshot.md": 1191,
	"./ca": 488,
	"./ca/": 488,
	"./ca/_lib/formatDistance": 198,
	"./ca/_lib/formatDistance/": 198,
	"./ca/_lib/formatDistance/index": 198,
	"./ca/_lib/formatDistance/index.js": 198,
	"./ca/_lib/formatLong": 199,
	"./ca/_lib/formatLong/": 199,
	"./ca/_lib/formatLong/index": 199,
	"./ca/_lib/formatLong/index.js": 199,
	"./ca/_lib/formatRelative": 200,
	"./ca/_lib/formatRelative/": 200,
	"./ca/_lib/formatRelative/index": 200,
	"./ca/_lib/formatRelative/index.js": 200,
	"./ca/_lib/localize": 201,
	"./ca/_lib/localize/": 201,
	"./ca/_lib/localize/index": 201,
	"./ca/_lib/localize/index.js": 201,
	"./ca/_lib/match": 202,
	"./ca/_lib/match/": 202,
	"./ca/_lib/match/index": 202,
	"./ca/_lib/match/index.js": 202,
	"./ca/index": 645,
	"./ca/index.d.ts": 1192,
	"./ca/index.js": 645,
	"./ca/index.js.flow": 1193,
	"./ca/package": 826,
	"./ca/package.json": 826,
	"./ca/snapshot.md": 1194,
	"./cs": 489,
	"./cs/": 489,
	"./cs/_lib/formatDistance": 203,
	"./cs/_lib/formatDistance/": 203,
	"./cs/_lib/formatDistance/index": 203,
	"./cs/_lib/formatDistance/index.js": 203,
	"./cs/_lib/formatLong": 204,
	"./cs/_lib/formatLong/": 204,
	"./cs/_lib/formatLong/index": 204,
	"./cs/_lib/formatLong/index.js": 204,
	"./cs/_lib/formatRelative": 205,
	"./cs/_lib/formatRelative/": 205,
	"./cs/_lib/formatRelative/index": 205,
	"./cs/_lib/formatRelative/index.js": 205,
	"./cs/_lib/localize": 206,
	"./cs/_lib/localize/": 206,
	"./cs/_lib/localize/index": 206,
	"./cs/_lib/localize/index.js": 206,
	"./cs/_lib/match": 207,
	"./cs/_lib/match/": 207,
	"./cs/_lib/match/index": 207,
	"./cs/_lib/match/index.js": 207,
	"./cs/index": 646,
	"./cs/index.d.ts": 1195,
	"./cs/index.js": 646,
	"./cs/index.js.flow": 1196,
	"./cs/package": 827,
	"./cs/package.json": 827,
	"./cs/snapshot.md": 1197,
	"./cy": 490,
	"./cy/": 490,
	"./cy/_lib/formatDistance": 208,
	"./cy/_lib/formatDistance/": 208,
	"./cy/_lib/formatDistance/index": 208,
	"./cy/_lib/formatDistance/index.js": 208,
	"./cy/_lib/formatLong": 209,
	"./cy/_lib/formatLong/": 209,
	"./cy/_lib/formatLong/index": 209,
	"./cy/_lib/formatLong/index.js": 209,
	"./cy/_lib/formatRelative": 210,
	"./cy/_lib/formatRelative/": 210,
	"./cy/_lib/formatRelative/index": 210,
	"./cy/_lib/formatRelative/index.js": 210,
	"./cy/_lib/localize": 211,
	"./cy/_lib/localize/": 211,
	"./cy/_lib/localize/index": 211,
	"./cy/_lib/localize/index.js": 211,
	"./cy/_lib/match": 212,
	"./cy/_lib/match/": 212,
	"./cy/_lib/match/index": 212,
	"./cy/_lib/match/index.js": 212,
	"./cy/index": 647,
	"./cy/index.d.ts": 1198,
	"./cy/index.js": 647,
	"./cy/index.js.flow": 1199,
	"./cy/package": 828,
	"./cy/package.json": 828,
	"./cy/snapshot.md": 1200,
	"./da": 491,
	"./da/": 491,
	"./da/_lib/formatDistance": 213,
	"./da/_lib/formatDistance/": 213,
	"./da/_lib/formatDistance/index": 213,
	"./da/_lib/formatDistance/index.js": 213,
	"./da/_lib/formatLong": 214,
	"./da/_lib/formatLong/": 214,
	"./da/_lib/formatLong/index": 214,
	"./da/_lib/formatLong/index.js": 214,
	"./da/_lib/formatRelative": 215,
	"./da/_lib/formatRelative/": 215,
	"./da/_lib/formatRelative/index": 215,
	"./da/_lib/formatRelative/index.js": 215,
	"./da/_lib/localize": 216,
	"./da/_lib/localize/": 216,
	"./da/_lib/localize/index": 216,
	"./da/_lib/localize/index.js": 216,
	"./da/_lib/match": 217,
	"./da/_lib/match/": 217,
	"./da/_lib/match/index": 217,
	"./da/_lib/match/index.js": 217,
	"./da/index": 648,
	"./da/index.d.ts": 1201,
	"./da/index.js": 648,
	"./da/index.js.flow": 1202,
	"./da/package": 829,
	"./da/package.json": 829,
	"./da/snapshot.md": 1203,
	"./de": 120,
	"./de/": 120,
	"./de/_lib/formatDistance": 218,
	"./de/_lib/formatDistance/": 218,
	"./de/_lib/formatDistance/index": 218,
	"./de/_lib/formatDistance/index.js": 218,
	"./de/_lib/formatLong": 219,
	"./de/_lib/formatLong/": 219,
	"./de/_lib/formatLong/index": 219,
	"./de/_lib/formatLong/index.js": 219,
	"./de/_lib/formatRelative": 220,
	"./de/_lib/formatRelative/": 220,
	"./de/_lib/formatRelative/index": 220,
	"./de/_lib/formatRelative/index.js": 220,
	"./de/_lib/localize": 221,
	"./de/_lib/localize/": 221,
	"./de/_lib/localize/index": 221,
	"./de/_lib/localize/index.js": 221,
	"./de/_lib/match": 222,
	"./de/_lib/match/": 222,
	"./de/_lib/match/index": 222,
	"./de/_lib/match/index.js": 222,
	"./de/index": 649,
	"./de/index.d.ts": 1204,
	"./de/index.js": 649,
	"./de/index.js.flow": 1205,
	"./de/package": 830,
	"./de/package.json": 830,
	"./de/snapshot.md": 1206,
	"./el": 121,
	"./el/": 121,
	"./el/_lib/formatDistance": 223,
	"./el/_lib/formatDistance/": 223,
	"./el/_lib/formatDistance/index": 223,
	"./el/_lib/formatDistance/index.js": 223,
	"./el/_lib/formatLong": 224,
	"./el/_lib/formatLong/": 224,
	"./el/_lib/formatLong/index": 224,
	"./el/_lib/formatLong/index.js": 224,
	"./el/_lib/formatRelative": 225,
	"./el/_lib/formatRelative/": 225,
	"./el/_lib/formatRelative/index": 225,
	"./el/_lib/formatRelative/index.js": 225,
	"./el/_lib/localize": 226,
	"./el/_lib/localize/": 226,
	"./el/_lib/localize/index": 226,
	"./el/_lib/localize/index.js": 226,
	"./el/_lib/match": 227,
	"./el/_lib/match/": 227,
	"./el/_lib/match/index": 227,
	"./el/_lib/match/index.js": 227,
	"./el/index": 650,
	"./el/index.d.ts": 1207,
	"./el/index.js": 650,
	"./el/index.js.flow": 1208,
	"./el/package": 831,
	"./el/package.json": 831,
	"./el/snapshot.md": 1209,
	"./en-AU": 532,
	"./en-AU/": 532,
	"./en-AU/_lib/formatLong": 228,
	"./en-AU/_lib/formatLong/": 228,
	"./en-AU/_lib/formatLong/index": 228,
	"./en-AU/_lib/formatLong/index.js": 228,
	"./en-AU/index": 651,
	"./en-AU/index.d.ts": 1210,
	"./en-AU/index.js": 651,
	"./en-AU/index.js.flow": 1211,
	"./en-AU/package": 832,
	"./en-AU/package.json": 832,
	"./en-AU/snapshot.md": 1212,
	"./en-CA": 531,
	"./en-CA/": 531,
	"./en-CA/_lib/formatDistance": 229,
	"./en-CA/_lib/formatDistance/": 229,
	"./en-CA/_lib/formatDistance/index": 229,
	"./en-CA/_lib/formatDistance/index.js": 229,
	"./en-CA/_lib/formatLong": 230,
	"./en-CA/_lib/formatLong/": 230,
	"./en-CA/_lib/formatLong/index": 230,
	"./en-CA/_lib/formatLong/index.js": 230,
	"./en-CA/index": 652,
	"./en-CA/index.d.ts": 1213,
	"./en-CA/index.js": 652,
	"./en-CA/index.js.flow": 1214,
	"./en-CA/package": 833,
	"./en-CA/package.json": 833,
	"./en-CA/snapshot.md": 1215,
	"./en-GB": 56,
	"./en-GB/": 56,
	"./en-GB/_lib/formatLong": 231,
	"./en-GB/_lib/formatLong/": 231,
	"./en-GB/_lib/formatLong/index": 231,
	"./en-GB/_lib/formatLong/index.js": 231,
	"./en-GB/index": 653,
	"./en-GB/index.d.ts": 1216,
	"./en-GB/index.js": 653,
	"./en-GB/index.js.flow": 1217,
	"./en-GB/package": 834,
	"./en-GB/package.json": 834,
	"./en-GB/snapshot.md": 1218,
	"./en-IN": 533,
	"./en-IN/": 533,
	"./en-IN/_lib/formatLong": 232,
	"./en-IN/_lib/formatLong/": 232,
	"./en-IN/_lib/formatLong/index": 232,
	"./en-IN/_lib/formatLong/index.js": 232,
	"./en-IN/index": 654,
	"./en-IN/index.d.ts": 1219,
	"./en-IN/index.js": 654,
	"./en-IN/index.js.flow": 1220,
	"./en-IN/package": 835,
	"./en-IN/package.json": 835,
	"./en-IN/snapshot.md": 1221,
	"./en-US": 75,
	"./en-US/": 75,
	"./en-US/_lib/formatDistance": 80,
	"./en-US/_lib/formatDistance/": 80,
	"./en-US/_lib/formatDistance/index": 80,
	"./en-US/_lib/formatDistance/index.js": 80,
	"./en-US/_lib/formatLong": 233,
	"./en-US/_lib/formatLong/": 233,
	"./en-US/_lib/formatLong/index": 233,
	"./en-US/_lib/formatLong/index.js": 233,
	"./en-US/_lib/formatRelative": 72,
	"./en-US/_lib/formatRelative/": 72,
	"./en-US/_lib/formatRelative/index": 72,
	"./en-US/_lib/formatRelative/index.js": 72,
	"./en-US/_lib/localize": 73,
	"./en-US/_lib/localize/": 73,
	"./en-US/_lib/localize/index": 73,
	"./en-US/_lib/localize/index.js": 73,
	"./en-US/_lib/match": 74,
	"./en-US/_lib/match/": 74,
	"./en-US/_lib/match/index": 74,
	"./en-US/_lib/match/index.js": 74,
	"./en-US/index": 655,
	"./en-US/index.d.ts": 1222,
	"./en-US/index.js": 655,
	"./en-US/index.js.flow": 1223,
	"./en-US/package": 836,
	"./en-US/package.json": 836,
	"./en-US/snapshot.md": 1224,
	"./eo": 492,
	"./eo/": 492,
	"./eo/_lib/formatDistance": 234,
	"./eo/_lib/formatDistance/": 234,
	"./eo/_lib/formatDistance/index": 234,
	"./eo/_lib/formatDistance/index.js": 234,
	"./eo/_lib/formatLong": 235,
	"./eo/_lib/formatLong/": 235,
	"./eo/_lib/formatLong/index": 235,
	"./eo/_lib/formatLong/index.js": 235,
	"./eo/_lib/formatRelative": 236,
	"./eo/_lib/formatRelative/": 236,
	"./eo/_lib/formatRelative/index": 236,
	"./eo/_lib/formatRelative/index.js": 236,
	"./eo/_lib/localize": 237,
	"./eo/_lib/localize/": 237,
	"./eo/_lib/localize/index": 237,
	"./eo/_lib/localize/index.js": 237,
	"./eo/_lib/match": 238,
	"./eo/_lib/match/": 238,
	"./eo/_lib/match/index": 238,
	"./eo/_lib/match/index.js": 238,
	"./eo/index": 656,
	"./eo/index.d.ts": 1225,
	"./eo/index.js": 656,
	"./eo/index.js.flow": 1226,
	"./eo/package": 837,
	"./eo/package.json": 837,
	"./eo/snapshot.md": 1227,
	"./es": 122,
	"./es/": 122,
	"./es/_lib/formatDistance": 239,
	"./es/_lib/formatDistance/": 239,
	"./es/_lib/formatDistance/index": 239,
	"./es/_lib/formatDistance/index.js": 239,
	"./es/_lib/formatLong": 240,
	"./es/_lib/formatLong/": 240,
	"./es/_lib/formatLong/index": 240,
	"./es/_lib/formatLong/index.js": 240,
	"./es/_lib/formatRelative": 241,
	"./es/_lib/formatRelative/": 241,
	"./es/_lib/formatRelative/index": 241,
	"./es/_lib/formatRelative/index.js": 241,
	"./es/_lib/localize": 242,
	"./es/_lib/localize/": 242,
	"./es/_lib/localize/index": 242,
	"./es/_lib/localize/index.js": 242,
	"./es/_lib/match": 243,
	"./es/_lib/match/": 243,
	"./es/_lib/match/index": 243,
	"./es/_lib/match/index.js": 243,
	"./es/index": 657,
	"./es/index.d.ts": 1228,
	"./es/index.js": 657,
	"./es/index.js.flow": 1229,
	"./es/package": 838,
	"./es/package.json": 838,
	"./es/snapshot.md": 1230,
	"./et": 493,
	"./et/": 493,
	"./et/_lib/formatDistance": 244,
	"./et/_lib/formatDistance/": 244,
	"./et/_lib/formatDistance/index": 244,
	"./et/_lib/formatDistance/index.js": 244,
	"./et/_lib/formatLong": 245,
	"./et/_lib/formatLong/": 245,
	"./et/_lib/formatLong/index": 245,
	"./et/_lib/formatLong/index.js": 245,
	"./et/_lib/formatRelative": 246,
	"./et/_lib/formatRelative/": 246,
	"./et/_lib/formatRelative/index": 246,
	"./et/_lib/formatRelative/index.js": 246,
	"./et/_lib/localize": 247,
	"./et/_lib/localize/": 247,
	"./et/_lib/localize/index": 247,
	"./et/_lib/localize/index.js": 247,
	"./et/_lib/match": 248,
	"./et/_lib/match/": 248,
	"./et/_lib/match/index": 248,
	"./et/_lib/match/index.js": 248,
	"./et/index": 658,
	"./et/index.d.ts": 1231,
	"./et/index.js": 658,
	"./et/index.js.flow": 1232,
	"./et/package": 839,
	"./et/package.json": 839,
	"./et/snapshot.md": 1233,
	"./eu": 494,
	"./eu/": 494,
	"./eu/_lib/formatDistance": 249,
	"./eu/_lib/formatDistance/": 249,
	"./eu/_lib/formatDistance/index": 249,
	"./eu/_lib/formatDistance/index.js": 249,
	"./eu/_lib/formatLong": 250,
	"./eu/_lib/formatLong/": 250,
	"./eu/_lib/formatLong/index": 250,
	"./eu/_lib/formatLong/index.js": 250,
	"./eu/_lib/formatRelative": 251,
	"./eu/_lib/formatRelative/": 251,
	"./eu/_lib/formatRelative/index": 251,
	"./eu/_lib/formatRelative/index.js": 251,
	"./eu/_lib/localize": 252,
	"./eu/_lib/localize/": 252,
	"./eu/_lib/localize/index": 252,
	"./eu/_lib/localize/index.js": 252,
	"./eu/_lib/match": 253,
	"./eu/_lib/match/": 253,
	"./eu/_lib/match/index": 253,
	"./eu/_lib/match/index.js": 253,
	"./eu/index": 659,
	"./eu/index.d.ts": 1234,
	"./eu/index.js": 659,
	"./eu/index.js.flow": 1235,
	"./eu/package": 840,
	"./eu/package.json": 840,
	"./eu/snapshot.md": 1236,
	"./fa-IR": 495,
	"./fa-IR/": 495,
	"./fa-IR/_lib/formatDistance": 254,
	"./fa-IR/_lib/formatDistance/": 254,
	"./fa-IR/_lib/formatDistance/index": 254,
	"./fa-IR/_lib/formatDistance/index.js": 254,
	"./fa-IR/_lib/formatLong": 255,
	"./fa-IR/_lib/formatLong/": 255,
	"./fa-IR/_lib/formatLong/index": 255,
	"./fa-IR/_lib/formatLong/index.js": 255,
	"./fa-IR/_lib/formatRelative": 256,
	"./fa-IR/_lib/formatRelative/": 256,
	"./fa-IR/_lib/formatRelative/index": 256,
	"./fa-IR/_lib/formatRelative/index.js": 256,
	"./fa-IR/_lib/localize": 257,
	"./fa-IR/_lib/localize/": 257,
	"./fa-IR/_lib/localize/index": 257,
	"./fa-IR/_lib/localize/index.js": 257,
	"./fa-IR/_lib/match": 258,
	"./fa-IR/_lib/match/": 258,
	"./fa-IR/_lib/match/index": 258,
	"./fa-IR/_lib/match/index.js": 258,
	"./fa-IR/index": 660,
	"./fa-IR/index.d.ts": 1237,
	"./fa-IR/index.js": 660,
	"./fa-IR/index.js.flow": 1238,
	"./fa-IR/package": 841,
	"./fa-IR/package.json": 841,
	"./fa-IR/snapshot.md": 1239,
	"./fi": 496,
	"./fi/": 496,
	"./fi/_lib/formatDistance": 259,
	"./fi/_lib/formatDistance/": 259,
	"./fi/_lib/formatDistance/index": 259,
	"./fi/_lib/formatDistance/index.js": 259,
	"./fi/_lib/formatLong": 260,
	"./fi/_lib/formatLong/": 260,
	"./fi/_lib/formatLong/index": 260,
	"./fi/_lib/formatLong/index.js": 260,
	"./fi/_lib/formatRelative": 261,
	"./fi/_lib/formatRelative/": 261,
	"./fi/_lib/formatRelative/index": 261,
	"./fi/_lib/formatRelative/index.js": 261,
	"./fi/_lib/localize": 262,
	"./fi/_lib/localize/": 262,
	"./fi/_lib/localize/index": 262,
	"./fi/_lib/localize/index.js": 262,
	"./fi/_lib/match": 263,
	"./fi/_lib/match/": 263,
	"./fi/_lib/match/index": 263,
	"./fi/_lib/match/index.js": 263,
	"./fi/index": 661,
	"./fi/index.d.ts": 1240,
	"./fi/index.js": 661,
	"./fi/index.js.flow": 1241,
	"./fi/package": 842,
	"./fi/package.json": 842,
	"./fi/snapshot.md": 1242,
	"./fr": 131,
	"./fr-CA": 534,
	"./fr-CA/": 534,
	"./fr-CA/_lib/formatLong": 264,
	"./fr-CA/_lib/formatLong/": 264,
	"./fr-CA/_lib/formatLong/index": 264,
	"./fr-CA/_lib/formatLong/index.js": 264,
	"./fr-CA/index": 662,
	"./fr-CA/index.d.ts": 1243,
	"./fr-CA/index.js": 662,
	"./fr-CA/index.js.flow": 1244,
	"./fr-CA/package": 843,
	"./fr-CA/package.json": 843,
	"./fr-CA/snapshot.md": 1245,
	"./fr/": 131,
	"./fr/_lib/formatDistance": 111,
	"./fr/_lib/formatDistance/": 111,
	"./fr/_lib/formatDistance/index": 111,
	"./fr/_lib/formatDistance/index.js": 111,
	"./fr/_lib/formatLong": 265,
	"./fr/_lib/formatLong/": 265,
	"./fr/_lib/formatLong/index": 265,
	"./fr/_lib/formatLong/index.js": 265,
	"./fr/_lib/formatRelative": 112,
	"./fr/_lib/formatRelative/": 112,
	"./fr/_lib/formatRelative/index": 112,
	"./fr/_lib/formatRelative/index.js": 112,
	"./fr/_lib/formatters": 569,
	"./fr/_lib/formatters/": 569,
	"./fr/_lib/formatters/index": 569,
	"./fr/_lib/formatters/index.js": 569,
	"./fr/_lib/localize": 113,
	"./fr/_lib/localize/": 113,
	"./fr/_lib/localize/index": 113,
	"./fr/_lib/localize/index.js": 113,
	"./fr/_lib/match": 114,
	"./fr/_lib/match/": 114,
	"./fr/_lib/match/index": 114,
	"./fr/_lib/match/index.js": 114,
	"./fr/index": 663,
	"./fr/index.d.ts": 1246,
	"./fr/index.js": 663,
	"./fr/index.js.flow": 1247,
	"./fr/package": 844,
	"./fr/package.json": 844,
	"./fr/snapshot.md": 1248,
	"./gl": 497,
	"./gl/": 497,
	"./gl/_lib/formatDistance": 266,
	"./gl/_lib/formatDistance/": 266,
	"./gl/_lib/formatDistance/index": 266,
	"./gl/_lib/formatDistance/index.js": 266,
	"./gl/_lib/formatLong": 267,
	"./gl/_lib/formatLong/": 267,
	"./gl/_lib/formatLong/index": 267,
	"./gl/_lib/formatLong/index.js": 267,
	"./gl/_lib/formatRelative": 268,
	"./gl/_lib/formatRelative/": 268,
	"./gl/_lib/formatRelative/index": 268,
	"./gl/_lib/formatRelative/index.js": 268,
	"./gl/_lib/localize": 269,
	"./gl/_lib/localize/": 269,
	"./gl/_lib/localize/index": 269,
	"./gl/_lib/localize/index.js": 269,
	"./gl/_lib/match": 270,
	"./gl/_lib/match/": 270,
	"./gl/_lib/match/index": 270,
	"./gl/_lib/match/index.js": 270,
	"./gl/index": 664,
	"./gl/index.d.ts": 1249,
	"./gl/index.js": 664,
	"./gl/index.js.flow": 1250,
	"./gl/package": 845,
	"./gl/package.json": 845,
	"./gl/snapshot.md": 1251,
	"./gu": 498,
	"./gu/": 498,
	"./gu/_lib/formatDistance": 271,
	"./gu/_lib/formatDistance/": 271,
	"./gu/_lib/formatDistance/index": 271,
	"./gu/_lib/formatDistance/index.js": 271,
	"./gu/_lib/formatLong": 272,
	"./gu/_lib/formatLong/": 272,
	"./gu/_lib/formatLong/index": 272,
	"./gu/_lib/formatLong/index.js": 272,
	"./gu/_lib/formatRelative": 273,
	"./gu/_lib/formatRelative/": 273,
	"./gu/_lib/formatRelative/index": 273,
	"./gu/_lib/formatRelative/index.js": 273,
	"./gu/_lib/localize": 274,
	"./gu/_lib/localize/": 274,
	"./gu/_lib/localize/index": 274,
	"./gu/_lib/localize/index.js": 274,
	"./gu/_lib/match": 275,
	"./gu/_lib/match/": 275,
	"./gu/_lib/match/index": 275,
	"./gu/_lib/match/index.js": 275,
	"./gu/index": 665,
	"./gu/index.d.ts": 1252,
	"./gu/index.js": 665,
	"./gu/index.js.flow": 1253,
	"./gu/package": 846,
	"./gu/package.json": 846,
	"./gu/snapshot.md": 1254,
	"./he": 123,
	"./he/": 123,
	"./he/_lib/formatDistance": 276,
	"./he/_lib/formatDistance/": 276,
	"./he/_lib/formatDistance/index": 276,
	"./he/_lib/formatDistance/index.js": 276,
	"./he/_lib/formatLong": 277,
	"./he/_lib/formatLong/": 277,
	"./he/_lib/formatLong/index": 277,
	"./he/_lib/formatLong/index.js": 277,
	"./he/_lib/formatRelative": 278,
	"./he/_lib/formatRelative/": 278,
	"./he/_lib/formatRelative/index": 278,
	"./he/_lib/formatRelative/index.js": 278,
	"./he/_lib/localize": 279,
	"./he/_lib/localize/": 279,
	"./he/_lib/localize/index": 279,
	"./he/_lib/localize/index.js": 279,
	"./he/_lib/match": 280,
	"./he/_lib/match/": 280,
	"./he/_lib/match/index": 280,
	"./he/_lib/match/index.js": 280,
	"./he/index": 666,
	"./he/index.d.ts": 1255,
	"./he/index.js": 666,
	"./he/index.js.flow": 1256,
	"./he/package": 847,
	"./he/package.json": 847,
	"./he/snapshot.md": 1257,
	"./hi": 124,
	"./hi/": 124,
	"./hi/_lib/formatDistance": 281,
	"./hi/_lib/formatDistance/": 281,
	"./hi/_lib/formatDistance/index": 281,
	"./hi/_lib/formatDistance/index.js": 281,
	"./hi/_lib/formatLong": 282,
	"./hi/_lib/formatLong/": 282,
	"./hi/_lib/formatLong/index": 282,
	"./hi/_lib/formatLong/index.js": 282,
	"./hi/_lib/formatRelative": 283,
	"./hi/_lib/formatRelative/": 283,
	"./hi/_lib/formatRelative/index": 283,
	"./hi/_lib/formatRelative/index.js": 283,
	"./hi/_lib/localize": 92,
	"./hi/_lib/localize/": 92,
	"./hi/_lib/localize/index": 92,
	"./hi/_lib/localize/index.js": 92,
	"./hi/_lib/match": 284,
	"./hi/_lib/match/": 284,
	"./hi/_lib/match/index": 284,
	"./hi/_lib/match/index.js": 284,
	"./hi/index": 667,
	"./hi/index.d.ts": 1258,
	"./hi/index.js": 667,
	"./hi/index.js.flow": 1259,
	"./hi/package": 848,
	"./hi/package.json": 848,
	"./hi/snapshot.md": 1260,
	"./hr": 499,
	"./hr/": 499,
	"./hr/_lib/formatDistance": 285,
	"./hr/_lib/formatDistance/": 285,
	"./hr/_lib/formatDistance/index": 285,
	"./hr/_lib/formatDistance/index.js": 285,
	"./hr/_lib/formatLong": 286,
	"./hr/_lib/formatLong/": 286,
	"./hr/_lib/formatLong/index": 286,
	"./hr/_lib/formatLong/index.js": 286,
	"./hr/_lib/formatRelative": 287,
	"./hr/_lib/formatRelative/": 287,
	"./hr/_lib/formatRelative/index": 287,
	"./hr/_lib/formatRelative/index.js": 287,
	"./hr/_lib/localize": 288,
	"./hr/_lib/localize/": 288,
	"./hr/_lib/localize/index": 288,
	"./hr/_lib/localize/index.js": 288,
	"./hr/_lib/match": 289,
	"./hr/_lib/match/": 289,
	"./hr/_lib/match/index": 289,
	"./hr/_lib/match/index.js": 289,
	"./hr/index": 668,
	"./hr/index.d.ts": 1261,
	"./hr/index.js": 668,
	"./hr/index.js.flow": 1262,
	"./hr/package": 849,
	"./hr/package.json": 849,
	"./hr/snapshot.md": 1263,
	"./hu": 500,
	"./hu/": 500,
	"./hu/_lib/formatDistance": 290,
	"./hu/_lib/formatDistance/": 290,
	"./hu/_lib/formatDistance/index": 290,
	"./hu/_lib/formatDistance/index.js": 290,
	"./hu/_lib/formatLong": 291,
	"./hu/_lib/formatLong/": 291,
	"./hu/_lib/formatLong/index": 291,
	"./hu/_lib/formatLong/index.js": 291,
	"./hu/_lib/formatRelative": 292,
	"./hu/_lib/formatRelative/": 292,
	"./hu/_lib/formatRelative/index": 292,
	"./hu/_lib/formatRelative/index.js": 292,
	"./hu/_lib/localize": 293,
	"./hu/_lib/localize/": 293,
	"./hu/_lib/localize/index": 293,
	"./hu/_lib/localize/index.js": 293,
	"./hu/_lib/match": 294,
	"./hu/_lib/match/": 294,
	"./hu/_lib/match/index": 294,
	"./hu/_lib/match/index.js": 294,
	"./hu/index": 669,
	"./hu/index.d.ts": 1265,
	"./hu/index.js": 669,
	"./hu/index.js.flow": 1266,
	"./hu/package": 850,
	"./hu/package.json": 850,
	"./hu/snapshot.md": 1267,
	"./hy": 501,
	"./hy/": 501,
	"./hy/_lib/formatDistance": 295,
	"./hy/_lib/formatDistance/": 295,
	"./hy/_lib/formatDistance/index": 295,
	"./hy/_lib/formatDistance/index.js": 295,
	"./hy/_lib/formatLong": 296,
	"./hy/_lib/formatLong/": 296,
	"./hy/_lib/formatLong/index": 296,
	"./hy/_lib/formatLong/index.js": 296,
	"./hy/_lib/formatRelative": 297,
	"./hy/_lib/formatRelative/": 297,
	"./hy/_lib/formatRelative/index": 297,
	"./hy/_lib/formatRelative/index.js": 297,
	"./hy/_lib/localize": 298,
	"./hy/_lib/localize/": 298,
	"./hy/_lib/localize/index": 298,
	"./hy/_lib/localize/index.js": 298,
	"./hy/_lib/match": 299,
	"./hy/_lib/match/": 299,
	"./hy/_lib/match/index": 299,
	"./hy/_lib/match/index.js": 299,
	"./hy/index": 670,
	"./hy/index.d.ts": 1268,
	"./hy/index.js": 670,
	"./hy/index.js.flow": 1269,
	"./hy/package": 851,
	"./hy/package.json": 851,
	"./hy/snapshot.md": 1270,
	"./id": 502,
	"./id/": 502,
	"./id/_lib/formatDistance": 300,
	"./id/_lib/formatDistance/": 300,
	"./id/_lib/formatDistance/index": 300,
	"./id/_lib/formatDistance/index.js": 300,
	"./id/_lib/formatLong": 301,
	"./id/_lib/formatLong/": 301,
	"./id/_lib/formatLong/index": 301,
	"./id/_lib/formatLong/index.js": 301,
	"./id/_lib/formatRelative": 302,
	"./id/_lib/formatRelative/": 302,
	"./id/_lib/formatRelative/index": 302,
	"./id/_lib/formatRelative/index.js": 302,
	"./id/_lib/localize": 303,
	"./id/_lib/localize/": 303,
	"./id/_lib/localize/index": 303,
	"./id/_lib/localize/index.js": 303,
	"./id/_lib/match": 304,
	"./id/_lib/match/": 304,
	"./id/_lib/match/index": 304,
	"./id/_lib/match/index.js": 304,
	"./id/index": 671,
	"./id/index.d.ts": 1271,
	"./id/index.js": 671,
	"./id/index.js.flow": 1272,
	"./id/package": 852,
	"./id/package.json": 852,
	"./id/snapshot.md": 1273,
	"./index": 853,
	"./index.js": 853,
	"./index.js.flow": 1274,
	"./is": 503,
	"./is/": 503,
	"./is/_lib/formatDistance": 305,
	"./is/_lib/formatDistance/": 305,
	"./is/_lib/formatDistance/index": 305,
	"./is/_lib/formatDistance/index.js": 305,
	"./is/_lib/formatLong": 306,
	"./is/_lib/formatLong/": 306,
	"./is/_lib/formatLong/index": 306,
	"./is/_lib/formatLong/index.js": 306,
	"./is/_lib/formatRelative": 307,
	"./is/_lib/formatRelative/": 307,
	"./is/_lib/formatRelative/index": 307,
	"./is/_lib/formatRelative/index.js": 307,
	"./is/_lib/localize": 308,
	"./is/_lib/localize/": 308,
	"./is/_lib/localize/index": 308,
	"./is/_lib/localize/index.js": 308,
	"./is/_lib/match": 309,
	"./is/_lib/match/": 309,
	"./is/_lib/match/index": 309,
	"./is/_lib/match/index.js": 309,
	"./is/index": 672,
	"./is/index.d.ts": 1275,
	"./is/index.js": 672,
	"./is/index.js.flow": 1276,
	"./is/package": 854,
	"./is/package.json": 854,
	"./is/snapshot.md": 1277,
	"./it": 125,
	"./it/": 125,
	"./it/_lib/formatDistance": 310,
	"./it/_lib/formatDistance/": 310,
	"./it/_lib/formatDistance/index": 310,
	"./it/_lib/formatDistance/index.js": 310,
	"./it/_lib/formatLong": 311,
	"./it/_lib/formatLong/": 311,
	"./it/_lib/formatLong/index": 311,
	"./it/_lib/formatLong/index.js": 311,
	"./it/_lib/formatRelative": 312,
	"./it/_lib/formatRelative/": 312,
	"./it/_lib/formatRelative/index": 312,
	"./it/_lib/formatRelative/index.js": 312,
	"./it/_lib/localize": 313,
	"./it/_lib/localize/": 313,
	"./it/_lib/localize/index": 313,
	"./it/_lib/localize/index.js": 313,
	"./it/_lib/match": 314,
	"./it/_lib/match/": 314,
	"./it/_lib/match/index": 314,
	"./it/_lib/match/index.js": 314,
	"./it/index": 673,
	"./it/index.d.ts": 1278,
	"./it/index.js": 673,
	"./it/index.js.flow": 1279,
	"./it/package": 855,
	"./it/package.json": 855,
	"./it/snapshot.md": 1280,
	"./ja": 126,
	"./ja/": 126,
	"./ja/_lib/formatDistance": 315,
	"./ja/_lib/formatDistance/": 315,
	"./ja/_lib/formatDistance/index": 315,
	"./ja/_lib/formatDistance/index.js": 315,
	"./ja/_lib/formatLong": 316,
	"./ja/_lib/formatLong/": 316,
	"./ja/_lib/formatLong/index": 316,
	"./ja/_lib/formatLong/index.js": 316,
	"./ja/_lib/formatRelative": 317,
	"./ja/_lib/formatRelative/": 317,
	"./ja/_lib/formatRelative/index": 317,
	"./ja/_lib/formatRelative/index.js": 317,
	"./ja/_lib/localize": 318,
	"./ja/_lib/localize/": 318,
	"./ja/_lib/localize/index": 318,
	"./ja/_lib/localize/index.js": 318,
	"./ja/_lib/match": 319,
	"./ja/_lib/match/": 319,
	"./ja/_lib/match/index": 319,
	"./ja/_lib/match/index.js": 319,
	"./ja/index": 674,
	"./ja/index.d.ts": 1281,
	"./ja/index.js": 674,
	"./ja/index.js.flow": 1282,
	"./ja/package": 856,
	"./ja/package.json": 856,
	"./ja/snapshot.md": 1283,
	"./ka": 504,
	"./ka/": 504,
	"./ka/_lib/formatDistance": 320,
	"./ka/_lib/formatDistance/": 320,
	"./ka/_lib/formatDistance/index": 320,
	"./ka/_lib/formatDistance/index.js": 320,
	"./ka/_lib/formatLong": 321,
	"./ka/_lib/formatLong/": 321,
	"./ka/_lib/formatLong/index": 321,
	"./ka/_lib/formatLong/index.js": 321,
	"./ka/_lib/formatRelative": 322,
	"./ka/_lib/formatRelative/": 322,
	"./ka/_lib/formatRelative/index": 322,
	"./ka/_lib/formatRelative/index.js": 322,
	"./ka/_lib/localize": 323,
	"./ka/_lib/localize/": 323,
	"./ka/_lib/localize/index": 323,
	"./ka/_lib/localize/index.js": 323,
	"./ka/_lib/match": 324,
	"./ka/_lib/match/": 324,
	"./ka/_lib/match/index": 324,
	"./ka/_lib/match/index.js": 324,
	"./ka/index": 675,
	"./ka/index.d.ts": 1284,
	"./ka/index.js": 675,
	"./ka/index.js.flow": 1285,
	"./ka/package": 857,
	"./ka/package.json": 857,
	"./ka/snapshot.md": 1286,
	"./kk": 505,
	"./kk/": 505,
	"./kk/_lib/formatDistance": 325,
	"./kk/_lib/formatDistance/": 325,
	"./kk/_lib/formatDistance/index": 325,
	"./kk/_lib/formatDistance/index.js": 325,
	"./kk/_lib/formatLong": 326,
	"./kk/_lib/formatLong/": 326,
	"./kk/_lib/formatLong/index": 326,
	"./kk/_lib/formatLong/index.js": 326,
	"./kk/_lib/formatRelative": 327,
	"./kk/_lib/formatRelative/": 327,
	"./kk/_lib/formatRelative/index": 327,
	"./kk/_lib/formatRelative/index.js": 327,
	"./kk/_lib/localize": 328,
	"./kk/_lib/localize/": 328,
	"./kk/_lib/localize/index": 328,
	"./kk/_lib/localize/index.js": 328,
	"./kk/_lib/match": 329,
	"./kk/_lib/match/": 329,
	"./kk/_lib/match/index": 329,
	"./kk/_lib/match/index.js": 329,
	"./kk/index": 676,
	"./kk/index.d.ts": 1287,
	"./kk/index.js": 676,
	"./kk/index.js.flow": 1288,
	"./kk/package": 858,
	"./kk/package.json": 858,
	"./kk/snapshot.md": 1289,
	"./kn": 506,
	"./kn/": 506,
	"./kn/_lib/formatDistance": 330,
	"./kn/_lib/formatDistance/": 330,
	"./kn/_lib/formatDistance/index": 330,
	"./kn/_lib/formatDistance/index.js": 330,
	"./kn/_lib/formatLong": 331,
	"./kn/_lib/formatLong/": 331,
	"./kn/_lib/formatLong/index": 331,
	"./kn/_lib/formatLong/index.js": 331,
	"./kn/_lib/formatRelative": 332,
	"./kn/_lib/formatRelative/": 332,
	"./kn/_lib/formatRelative/index": 332,
	"./kn/_lib/formatRelative/index.js": 332,
	"./kn/_lib/localize": 333,
	"./kn/_lib/localize/": 333,
	"./kn/_lib/localize/index": 333,
	"./kn/_lib/localize/index.js": 333,
	"./kn/_lib/match": 334,
	"./kn/_lib/match/": 334,
	"./kn/_lib/match/index": 334,
	"./kn/_lib/match/index.js": 334,
	"./kn/index": 677,
	"./kn/index.d.ts": 1290,
	"./kn/index.js": 677,
	"./kn/index.js.flow": 1291,
	"./kn/package": 859,
	"./kn/package.json": 859,
	"./kn/snapshot.md": 1292,
	"./ko": 127,
	"./ko/": 127,
	"./ko/_lib/formatDistance": 335,
	"./ko/_lib/formatDistance/": 335,
	"./ko/_lib/formatDistance/index": 335,
	"./ko/_lib/formatDistance/index.js": 335,
	"./ko/_lib/formatLong": 336,
	"./ko/_lib/formatLong/": 336,
	"./ko/_lib/formatLong/index": 336,
	"./ko/_lib/formatLong/index.js": 336,
	"./ko/_lib/formatRelative": 337,
	"./ko/_lib/formatRelative/": 337,
	"./ko/_lib/formatRelative/index": 337,
	"./ko/_lib/formatRelative/index.js": 337,
	"./ko/_lib/localize": 338,
	"./ko/_lib/localize/": 338,
	"./ko/_lib/localize/index": 338,
	"./ko/_lib/localize/index.js": 338,
	"./ko/_lib/match": 339,
	"./ko/_lib/match/": 339,
	"./ko/_lib/match/index": 339,
	"./ko/_lib/match/index.js": 339,
	"./ko/index": 678,
	"./ko/index.d.ts": 1293,
	"./ko/index.js": 678,
	"./ko/index.js.flow": 1294,
	"./ko/package": 860,
	"./ko/package.json": 860,
	"./ko/snapshot.md": 1295,
	"./lt": 507,
	"./lt/": 507,
	"./lt/_lib/formatDistance": 340,
	"./lt/_lib/formatDistance/": 340,
	"./lt/_lib/formatDistance/index": 340,
	"./lt/_lib/formatDistance/index.js": 340,
	"./lt/_lib/formatLong": 341,
	"./lt/_lib/formatLong/": 341,
	"./lt/_lib/formatLong/index": 341,
	"./lt/_lib/formatLong/index.js": 341,
	"./lt/_lib/formatRelative": 342,
	"./lt/_lib/formatRelative/": 342,
	"./lt/_lib/formatRelative/index": 342,
	"./lt/_lib/formatRelative/index.js": 342,
	"./lt/_lib/localize": 343,
	"./lt/_lib/localize/": 343,
	"./lt/_lib/localize/index": 343,
	"./lt/_lib/localize/index.js": 343,
	"./lt/_lib/match": 344,
	"./lt/_lib/match/": 344,
	"./lt/_lib/match/index": 344,
	"./lt/_lib/match/index.js": 344,
	"./lt/index": 679,
	"./lt/index.d.ts": 1296,
	"./lt/index.js": 679,
	"./lt/index.js.flow": 1297,
	"./lt/package": 861,
	"./lt/package.json": 861,
	"./lt/snapshot.md": 1298,
	"./lv": 508,
	"./lv/": 508,
	"./lv/_lib/formatDistance": 345,
	"./lv/_lib/formatDistance/": 345,
	"./lv/_lib/formatDistance/index": 345,
	"./lv/_lib/formatDistance/index.js": 345,
	"./lv/_lib/formatLong": 346,
	"./lv/_lib/formatLong/": 346,
	"./lv/_lib/formatLong/index": 346,
	"./lv/_lib/formatLong/index.js": 346,
	"./lv/_lib/formatRelative": 347,
	"./lv/_lib/formatRelative/": 347,
	"./lv/_lib/formatRelative/index": 347,
	"./lv/_lib/formatRelative/index.js": 347,
	"./lv/_lib/localize": 348,
	"./lv/_lib/localize/": 348,
	"./lv/_lib/localize/index": 348,
	"./lv/_lib/localize/index.js": 348,
	"./lv/_lib/match": 349,
	"./lv/_lib/match/": 349,
	"./lv/_lib/match/index": 349,
	"./lv/_lib/match/index.js": 349,
	"./lv/index": 680,
	"./lv/index.d.ts": 1299,
	"./lv/index.js": 680,
	"./lv/index.js.flow": 1300,
	"./lv/package": 862,
	"./lv/package.json": 862,
	"./lv/snapshot.md": 1301,
	"./mk": 509,
	"./mk/": 509,
	"./mk/_lib/formatDistance": 350,
	"./mk/_lib/formatDistance/": 350,
	"./mk/_lib/formatDistance/index": 350,
	"./mk/_lib/formatDistance/index.js": 350,
	"./mk/_lib/formatLong": 351,
	"./mk/_lib/formatLong/": 351,
	"./mk/_lib/formatLong/index": 351,
	"./mk/_lib/formatLong/index.js": 351,
	"./mk/_lib/formatRelative": 352,
	"./mk/_lib/formatRelative/": 352,
	"./mk/_lib/formatRelative/index": 352,
	"./mk/_lib/formatRelative/index.js": 352,
	"./mk/_lib/localize": 353,
	"./mk/_lib/localize/": 353,
	"./mk/_lib/localize/index": 353,
	"./mk/_lib/localize/index.js": 353,
	"./mk/_lib/match": 354,
	"./mk/_lib/match/": 354,
	"./mk/_lib/match/index": 354,
	"./mk/_lib/match/index.js": 354,
	"./mk/index": 681,
	"./mk/index.d.ts": 1302,
	"./mk/index.js": 681,
	"./mk/index.js.flow": 1303,
	"./mk/package": 863,
	"./mk/package.json": 863,
	"./mk/snapshot.md": 1304,
	"./ms": 510,
	"./ms/": 510,
	"./ms/_lib/formatDistance": 355,
	"./ms/_lib/formatDistance/": 355,
	"./ms/_lib/formatDistance/index": 355,
	"./ms/_lib/formatDistance/index.js": 355,
	"./ms/_lib/formatLong": 356,
	"./ms/_lib/formatLong/": 356,
	"./ms/_lib/formatLong/index": 356,
	"./ms/_lib/formatLong/index.js": 356,
	"./ms/_lib/formatRelative": 357,
	"./ms/_lib/formatRelative/": 357,
	"./ms/_lib/formatRelative/index": 357,
	"./ms/_lib/formatRelative/index.js": 357,
	"./ms/_lib/localize": 358,
	"./ms/_lib/localize/": 358,
	"./ms/_lib/localize/index": 358,
	"./ms/_lib/localize/index.js": 358,
	"./ms/_lib/match": 359,
	"./ms/_lib/match/": 359,
	"./ms/_lib/match/index": 359,
	"./ms/_lib/match/index.js": 359,
	"./ms/index": 682,
	"./ms/index.d.ts": 1305,
	"./ms/index.js": 682,
	"./ms/index.js.flow": 1306,
	"./ms/package": 864,
	"./ms/package.json": 864,
	"./ms/snapshot.md": 1307,
	"./mt": 511,
	"./mt/": 511,
	"./mt/_lib/formatDistance": 360,
	"./mt/_lib/formatDistance/": 360,
	"./mt/_lib/formatDistance/index": 360,
	"./mt/_lib/formatDistance/index.js": 360,
	"./mt/_lib/formatLong": 361,
	"./mt/_lib/formatLong/": 361,
	"./mt/_lib/formatLong/index": 361,
	"./mt/_lib/formatLong/index.js": 361,
	"./mt/_lib/formatRelative": 362,
	"./mt/_lib/formatRelative/": 362,
	"./mt/_lib/formatRelative/index": 362,
	"./mt/_lib/formatRelative/index.js": 362,
	"./mt/_lib/localize": 363,
	"./mt/_lib/localize/": 363,
	"./mt/_lib/localize/index": 363,
	"./mt/_lib/localize/index.js": 363,
	"./mt/_lib/match": 364,
	"./mt/_lib/match/": 364,
	"./mt/_lib/match/index": 364,
	"./mt/_lib/match/index.js": 364,
	"./mt/index": 683,
	"./mt/index.d.ts": 1308,
	"./mt/index.js": 683,
	"./mt/index.js.flow": 1309,
	"./mt/package": 865,
	"./mt/package.json": 865,
	"./mt/snapshot.md": 1310,
	"./nb": 512,
	"./nb/": 512,
	"./nb/_lib/formatDistance": 365,
	"./nb/_lib/formatDistance/": 365,
	"./nb/_lib/formatDistance/index": 365,
	"./nb/_lib/formatDistance/index.js": 365,
	"./nb/_lib/formatLong": 366,
	"./nb/_lib/formatLong/": 366,
	"./nb/_lib/formatLong/index": 366,
	"./nb/_lib/formatLong/index.js": 366,
	"./nb/_lib/formatRelative": 367,
	"./nb/_lib/formatRelative/": 367,
	"./nb/_lib/formatRelative/index": 367,
	"./nb/_lib/formatRelative/index.js": 367,
	"./nb/_lib/localize": 368,
	"./nb/_lib/localize/": 368,
	"./nb/_lib/localize/index": 368,
	"./nb/_lib/localize/index.js": 368,
	"./nb/_lib/match": 369,
	"./nb/_lib/match/": 369,
	"./nb/_lib/match/index": 369,
	"./nb/_lib/match/index.js": 369,
	"./nb/index": 684,
	"./nb/index.d.ts": 1311,
	"./nb/index.js": 684,
	"./nb/index.js.flow": 1312,
	"./nb/package": 866,
	"./nb/package.json": 866,
	"./nb/snapshot.md": 1313,
	"./nl": 513,
	"./nl/": 513,
	"./nl/_lib/formatDistance": 370,
	"./nl/_lib/formatDistance/": 370,
	"./nl/_lib/formatDistance/index": 370,
	"./nl/_lib/formatDistance/index.js": 370,
	"./nl/_lib/formatLong": 371,
	"./nl/_lib/formatLong/": 371,
	"./nl/_lib/formatLong/index": 371,
	"./nl/_lib/formatLong/index.js": 371,
	"./nl/_lib/formatRelative": 372,
	"./nl/_lib/formatRelative/": 372,
	"./nl/_lib/formatRelative/index": 372,
	"./nl/_lib/formatRelative/index.js": 372,
	"./nl/_lib/localize": 373,
	"./nl/_lib/localize/": 373,
	"./nl/_lib/localize/index": 373,
	"./nl/_lib/localize/index.js": 373,
	"./nl/_lib/match": 374,
	"./nl/_lib/match/": 374,
	"./nl/_lib/match/index": 374,
	"./nl/_lib/match/index.js": 374,
	"./nl/index": 685,
	"./nl/index.d.ts": 1314,
	"./nl/index.js": 685,
	"./nl/index.js.flow": 1315,
	"./nl/package": 867,
	"./nl/package.json": 867,
	"./nl/snapshot.md": 1316,
	"./nn": 514,
	"./nn/": 514,
	"./nn/_lib/formatDistance": 375,
	"./nn/_lib/formatDistance/": 375,
	"./nn/_lib/formatDistance/index": 375,
	"./nn/_lib/formatDistance/index.js": 375,
	"./nn/_lib/formatLong": 376,
	"./nn/_lib/formatLong/": 376,
	"./nn/_lib/formatLong/index": 376,
	"./nn/_lib/formatLong/index.js": 376,
	"./nn/_lib/formatRelative": 377,
	"./nn/_lib/formatRelative/": 377,
	"./nn/_lib/formatRelative/index": 377,
	"./nn/_lib/formatRelative/index.js": 377,
	"./nn/_lib/localize": 378,
	"./nn/_lib/localize/": 378,
	"./nn/_lib/localize/index": 378,
	"./nn/_lib/localize/index.js": 378,
	"./nn/_lib/match": 379,
	"./nn/_lib/match/": 379,
	"./nn/_lib/match/index": 379,
	"./nn/_lib/match/index.js": 379,
	"./nn/index": 686,
	"./nn/index.d.ts": 1317,
	"./nn/index.js": 686,
	"./nn/index.js.flow": 1318,
	"./nn/package": 868,
	"./nn/package.json": 868,
	"./nn/snapshot.md": 1319,
	"./package": 869,
	"./package.json": 869,
	"./pl": 515,
	"./pl/": 515,
	"./pl/_lib/formatDistance": 380,
	"./pl/_lib/formatDistance/": 380,
	"./pl/_lib/formatDistance/index": 380,
	"./pl/_lib/formatDistance/index.js": 380,
	"./pl/_lib/formatLong": 381,
	"./pl/_lib/formatLong/": 381,
	"./pl/_lib/formatLong/index": 381,
	"./pl/_lib/formatLong/index.js": 381,
	"./pl/_lib/formatRelative": 382,
	"./pl/_lib/formatRelative/": 382,
	"./pl/_lib/formatRelative/index": 382,
	"./pl/_lib/formatRelative/index.js": 382,
	"./pl/_lib/localize": 383,
	"./pl/_lib/localize/": 383,
	"./pl/_lib/localize/index": 383,
	"./pl/_lib/localize/index.js": 383,
	"./pl/_lib/match": 384,
	"./pl/_lib/match/": 384,
	"./pl/_lib/match/index": 384,
	"./pl/_lib/match/index.js": 384,
	"./pl/index": 687,
	"./pl/index.d.ts": 1320,
	"./pl/index.js": 687,
	"./pl/index.js.flow": 1321,
	"./pl/package": 870,
	"./pl/package.json": 870,
	"./pl/snapshot.md": 1322,
	"./pt": 128,
	"./pt-BR": 516,
	"./pt-BR/": 516,
	"./pt-BR/_lib/formatDistance": 390,
	"./pt-BR/_lib/formatDistance/": 390,
	"./pt-BR/_lib/formatDistance/index": 390,
	"./pt-BR/_lib/formatDistance/index.js": 390,
	"./pt-BR/_lib/formatLong": 391,
	"./pt-BR/_lib/formatLong/": 391,
	"./pt-BR/_lib/formatLong/index": 391,
	"./pt-BR/_lib/formatLong/index.js": 391,
	"./pt-BR/_lib/formatRelative": 392,
	"./pt-BR/_lib/formatRelative/": 392,
	"./pt-BR/_lib/formatRelative/index": 392,
	"./pt-BR/_lib/formatRelative/index.js": 392,
	"./pt-BR/_lib/localize": 393,
	"./pt-BR/_lib/localize/": 393,
	"./pt-BR/_lib/localize/index": 393,
	"./pt-BR/_lib/localize/index.js": 393,
	"./pt-BR/_lib/match": 394,
	"./pt-BR/_lib/match/": 394,
	"./pt-BR/_lib/match/index": 394,
	"./pt-BR/_lib/match/index.js": 394,
	"./pt-BR/index": 689,
	"./pt-BR/index.d.ts": 1323,
	"./pt-BR/index.js": 689,
	"./pt-BR/index.js.flow": 1324,
	"./pt-BR/package": 871,
	"./pt-BR/package.json": 871,
	"./pt-BR/snapshot.md": 1325,
	"./pt/": 128,
	"./pt/_lib/formatDistance": 385,
	"./pt/_lib/formatDistance/": 385,
	"./pt/_lib/formatDistance/index": 385,
	"./pt/_lib/formatDistance/index.js": 385,
	"./pt/_lib/formatLong": 386,
	"./pt/_lib/formatLong/": 386,
	"./pt/_lib/formatLong/index": 386,
	"./pt/_lib/formatLong/index.js": 386,
	"./pt/_lib/formatRelative": 387,
	"./pt/_lib/formatRelative/": 387,
	"./pt/_lib/formatRelative/index": 387,
	"./pt/_lib/formatRelative/index.js": 387,
	"./pt/_lib/localize": 388,
	"./pt/_lib/localize/": 388,
	"./pt/_lib/localize/index": 388,
	"./pt/_lib/localize/index.js": 388,
	"./pt/_lib/match": 389,
	"./pt/_lib/match/": 389,
	"./pt/_lib/match/index": 389,
	"./pt/_lib/match/index.js": 389,
	"./pt/index": 688,
	"./pt/index.d.ts": 1326,
	"./pt/index.js": 688,
	"./pt/index.js.flow": 1327,
	"./pt/package": 872,
	"./pt/package.json": 872,
	"./pt/snapshot.md": 1328,
	"./ro": 517,
	"./ro/": 517,
	"./ro/_lib/formatDistance": 395,
	"./ro/_lib/formatDistance/": 395,
	"./ro/_lib/formatDistance/index": 395,
	"./ro/_lib/formatDistance/index.js": 395,
	"./ro/_lib/formatLong": 396,
	"./ro/_lib/formatLong/": 396,
	"./ro/_lib/formatLong/index": 396,
	"./ro/_lib/formatLong/index.js": 396,
	"./ro/_lib/formatRelative": 397,
	"./ro/_lib/formatRelative/": 397,
	"./ro/_lib/formatRelative/index": 397,
	"./ro/_lib/formatRelative/index.js": 397,
	"./ro/_lib/localize": 398,
	"./ro/_lib/localize/": 398,
	"./ro/_lib/localize/index": 398,
	"./ro/_lib/localize/index.js": 398,
	"./ro/_lib/match": 399,
	"./ro/_lib/match/": 399,
	"./ro/_lib/match/index": 399,
	"./ro/_lib/match/index.js": 399,
	"./ro/index": 690,
	"./ro/index.d.ts": 1329,
	"./ro/index.js": 690,
	"./ro/index.js.flow": 1330,
	"./ro/package": 873,
	"./ro/package.json": 873,
	"./ro/snapshot.md": 1331,
	"./ru": 129,
	"./ru/": 129,
	"./ru/_lib/formatDistance": 400,
	"./ru/_lib/formatDistance/": 400,
	"./ru/_lib/formatDistance/index": 400,
	"./ru/_lib/formatDistance/index.js": 400,
	"./ru/_lib/formatLong": 401,
	"./ru/_lib/formatLong/": 401,
	"./ru/_lib/formatLong/index": 401,
	"./ru/_lib/formatLong/index.js": 401,
	"./ru/_lib/formatRelative": 402,
	"./ru/_lib/formatRelative/": 402,
	"./ru/_lib/formatRelative/index": 402,
	"./ru/_lib/formatRelative/index.js": 402,
	"./ru/_lib/localize": 403,
	"./ru/_lib/localize/": 403,
	"./ru/_lib/localize/index": 403,
	"./ru/_lib/localize/index.js": 403,
	"./ru/_lib/match": 404,
	"./ru/_lib/match/": 404,
	"./ru/_lib/match/index": 404,
	"./ru/_lib/match/index.js": 404,
	"./ru/index": 691,
	"./ru/index.d.ts": 1332,
	"./ru/index.js": 691,
	"./ru/index.js.flow": 1333,
	"./ru/package": 874,
	"./ru/package.json": 874,
	"./ru/snapshot.md": 1334,
	"./sk": 518,
	"./sk/": 518,
	"./sk/_lib/formatDistance": 405,
	"./sk/_lib/formatDistance/": 405,
	"./sk/_lib/formatDistance/index": 405,
	"./sk/_lib/formatDistance/index.js": 405,
	"./sk/_lib/formatLong": 406,
	"./sk/_lib/formatLong/": 406,
	"./sk/_lib/formatLong/index": 406,
	"./sk/_lib/formatLong/index.js": 406,
	"./sk/_lib/formatRelative": 407,
	"./sk/_lib/formatRelative/": 407,
	"./sk/_lib/formatRelative/index": 407,
	"./sk/_lib/formatRelative/index.js": 407,
	"./sk/_lib/localize": 408,
	"./sk/_lib/localize/": 408,
	"./sk/_lib/localize/index": 408,
	"./sk/_lib/localize/index.js": 408,
	"./sk/_lib/match": 409,
	"./sk/_lib/match/": 409,
	"./sk/_lib/match/index": 409,
	"./sk/_lib/match/index.js": 409,
	"./sk/index": 692,
	"./sk/index.d.ts": 1335,
	"./sk/index.js": 692,
	"./sk/index.js.flow": 1336,
	"./sk/package": 875,
	"./sk/package.json": 875,
	"./sk/snapshot.md": 1337,
	"./sl": 519,
	"./sl/": 519,
	"./sl/_lib/formatDistance": 410,
	"./sl/_lib/formatDistance/": 410,
	"./sl/_lib/formatDistance/index": 410,
	"./sl/_lib/formatDistance/index.js": 410,
	"./sl/_lib/formatLong": 411,
	"./sl/_lib/formatLong/": 411,
	"./sl/_lib/formatLong/index": 411,
	"./sl/_lib/formatLong/index.js": 411,
	"./sl/_lib/formatRelative": 412,
	"./sl/_lib/formatRelative/": 412,
	"./sl/_lib/formatRelative/index": 412,
	"./sl/_lib/formatRelative/index.js": 412,
	"./sl/_lib/localize": 413,
	"./sl/_lib/localize/": 413,
	"./sl/_lib/localize/index": 413,
	"./sl/_lib/localize/index.js": 413,
	"./sl/_lib/match": 414,
	"./sl/_lib/match/": 414,
	"./sl/_lib/match/index": 414,
	"./sl/_lib/match/index.js": 414,
	"./sl/index": 693,
	"./sl/index.d.ts": 1338,
	"./sl/index.js": 693,
	"./sl/index.js.flow": 1339,
	"./sl/package": 876,
	"./sl/package.json": 876,
	"./sl/snapshot.md": 1340,
	"./sr": 520,
	"./sr-Latn": 521,
	"./sr-Latn/": 521,
	"./sr-Latn/_lib/formatDistance": 420,
	"./sr-Latn/_lib/formatDistance/": 420,
	"./sr-Latn/_lib/formatDistance/index": 420,
	"./sr-Latn/_lib/formatDistance/index.js": 420,
	"./sr-Latn/_lib/formatLong": 421,
	"./sr-Latn/_lib/formatLong/": 421,
	"./sr-Latn/_lib/formatLong/index": 421,
	"./sr-Latn/_lib/formatLong/index.js": 421,
	"./sr-Latn/_lib/formatRelative": 422,
	"./sr-Latn/_lib/formatRelative/": 422,
	"./sr-Latn/_lib/formatRelative/index": 422,
	"./sr-Latn/_lib/formatRelative/index.js": 422,
	"./sr-Latn/_lib/localize": 423,
	"./sr-Latn/_lib/localize/": 423,
	"./sr-Latn/_lib/localize/index": 423,
	"./sr-Latn/_lib/localize/index.js": 423,
	"./sr-Latn/_lib/match": 424,
	"./sr-Latn/_lib/match/": 424,
	"./sr-Latn/_lib/match/index": 424,
	"./sr-Latn/_lib/match/index.js": 424,
	"./sr-Latn/index": 695,
	"./sr-Latn/index.d.ts": 1341,
	"./sr-Latn/index.js": 695,
	"./sr-Latn/index.js.flow": 1342,
	"./sr-Latn/package": 877,
	"./sr-Latn/package.json": 877,
	"./sr-Latn/snapshot.md": 1343,
	"./sr/": 520,
	"./sr/_lib/formatDistance": 415,
	"./sr/_lib/formatDistance/": 415,
	"./sr/_lib/formatDistance/index": 415,
	"./sr/_lib/formatDistance/index.js": 415,
	"./sr/_lib/formatLong": 416,
	"./sr/_lib/formatLong/": 416,
	"./sr/_lib/formatLong/index": 416,
	"./sr/_lib/formatLong/index.js": 416,
	"./sr/_lib/formatRelative": 417,
	"./sr/_lib/formatRelative/": 417,
	"./sr/_lib/formatRelative/index": 417,
	"./sr/_lib/formatRelative/index.js": 417,
	"./sr/_lib/localize": 418,
	"./sr/_lib/localize/": 418,
	"./sr/_lib/localize/index": 418,
	"./sr/_lib/localize/index.js": 418,
	"./sr/_lib/match": 419,
	"./sr/_lib/match/": 419,
	"./sr/_lib/match/index": 419,
	"./sr/_lib/match/index.js": 419,
	"./sr/index": 694,
	"./sr/index.d.ts": 1344,
	"./sr/index.js": 694,
	"./sr/index.js.flow": 1345,
	"./sr/package": 878,
	"./sr/package.json": 878,
	"./sr/snapshot.md": 1346,
	"./sv": 522,
	"./sv/": 522,
	"./sv/_lib/formatDistance": 425,
	"./sv/_lib/formatDistance/": 425,
	"./sv/_lib/formatDistance/index": 425,
	"./sv/_lib/formatDistance/index.js": 425,
	"./sv/_lib/formatLong": 426,
	"./sv/_lib/formatLong/": 426,
	"./sv/_lib/formatLong/index": 426,
	"./sv/_lib/formatLong/index.js": 426,
	"./sv/_lib/formatRelative": 427,
	"./sv/_lib/formatRelative/": 427,
	"./sv/_lib/formatRelative/index": 427,
	"./sv/_lib/formatRelative/index.js": 427,
	"./sv/_lib/localize": 428,
	"./sv/_lib/localize/": 428,
	"./sv/_lib/localize/index": 428,
	"./sv/_lib/localize/index.js": 428,
	"./sv/_lib/match": 429,
	"./sv/_lib/match/": 429,
	"./sv/_lib/match/index": 429,
	"./sv/_lib/match/index.js": 429,
	"./sv/index": 696,
	"./sv/index.d.ts": 1347,
	"./sv/index.js": 696,
	"./sv/index.js.flow": 1348,
	"./sv/package": 879,
	"./sv/package.json": 879,
	"./sv/snapshot.md": 1349,
	"./ta": 523,
	"./ta/": 523,
	"./ta/_lib/formatDistance": 430,
	"./ta/_lib/formatDistance/": 430,
	"./ta/_lib/formatDistance/index": 430,
	"./ta/_lib/formatDistance/index.js": 430,
	"./ta/_lib/formatLong": 431,
	"./ta/_lib/formatLong/": 431,
	"./ta/_lib/formatLong/index": 431,
	"./ta/_lib/formatLong/index.js": 431,
	"./ta/_lib/formatRelative": 432,
	"./ta/_lib/formatRelative/": 432,
	"./ta/_lib/formatRelative/index": 432,
	"./ta/_lib/formatRelative/index.js": 432,
	"./ta/_lib/localize": 433,
	"./ta/_lib/localize/": 433,
	"./ta/_lib/localize/index": 433,
	"./ta/_lib/localize/index.js": 433,
	"./ta/_lib/match": 434,
	"./ta/_lib/match/": 434,
	"./ta/_lib/match/index": 434,
	"./ta/_lib/match/index.js": 434,
	"./ta/index": 697,
	"./ta/index.d.ts": 1350,
	"./ta/index.js": 697,
	"./ta/index.js.flow": 1351,
	"./ta/package": 880,
	"./ta/package.json": 880,
	"./ta/snapshot.md": 1352,
	"./te": 524,
	"./te/": 524,
	"./te/_lib/formatDistance": 435,
	"./te/_lib/formatDistance/": 435,
	"./te/_lib/formatDistance/index": 435,
	"./te/_lib/formatDistance/index.js": 435,
	"./te/_lib/formatLong": 436,
	"./te/_lib/formatLong/": 436,
	"./te/_lib/formatLong/index": 436,
	"./te/_lib/formatLong/index.js": 436,
	"./te/_lib/formatRelative": 437,
	"./te/_lib/formatRelative/": 437,
	"./te/_lib/formatRelative/index": 437,
	"./te/_lib/formatRelative/index.js": 437,
	"./te/_lib/localize": 438,
	"./te/_lib/localize/": 438,
	"./te/_lib/localize/index": 438,
	"./te/_lib/localize/index.js": 438,
	"./te/_lib/match": 439,
	"./te/_lib/match/": 439,
	"./te/_lib/match/index": 439,
	"./te/_lib/match/index.js": 439,
	"./te/index": 698,
	"./te/index.d.ts": 1353,
	"./te/index.js": 698,
	"./te/index.js.flow": 1354,
	"./te/package": 881,
	"./te/package.json": 881,
	"./te/snapshot.md": 1355,
	"./th": 525,
	"./th/": 525,
	"./th/_lib/formatDistance": 440,
	"./th/_lib/formatDistance/": 440,
	"./th/_lib/formatDistance/index": 440,
	"./th/_lib/formatDistance/index.js": 440,
	"./th/_lib/formatLong": 441,
	"./th/_lib/formatLong/": 441,
	"./th/_lib/formatLong/index": 441,
	"./th/_lib/formatLong/index.js": 441,
	"./th/_lib/formatRelative": 442,
	"./th/_lib/formatRelative/": 442,
	"./th/_lib/formatRelative/index": 442,
	"./th/_lib/formatRelative/index.js": 442,
	"./th/_lib/localize": 443,
	"./th/_lib/localize/": 443,
	"./th/_lib/localize/index": 443,
	"./th/_lib/localize/index.js": 443,
	"./th/_lib/match": 444,
	"./th/_lib/match/": 444,
	"./th/_lib/match/index": 444,
	"./th/_lib/match/index.js": 444,
	"./th/index": 699,
	"./th/index.d.ts": 1356,
	"./th/index.js": 699,
	"./th/index.js.flow": 1357,
	"./th/package": 882,
	"./th/package.json": 882,
	"./th/snapshot.md": 1358,
	"./tr": 130,
	"./tr/": 130,
	"./tr/_lib/formatDistance": 445,
	"./tr/_lib/formatDistance/": 445,
	"./tr/_lib/formatDistance/index": 445,
	"./tr/_lib/formatDistance/index.js": 445,
	"./tr/_lib/formatLong": 446,
	"./tr/_lib/formatLong/": 446,
	"./tr/_lib/formatLong/index": 446,
	"./tr/_lib/formatLong/index.js": 446,
	"./tr/_lib/formatRelative": 447,
	"./tr/_lib/formatRelative/": 447,
	"./tr/_lib/formatRelative/index": 447,
	"./tr/_lib/formatRelative/index.js": 447,
	"./tr/_lib/localize": 448,
	"./tr/_lib/localize/": 448,
	"./tr/_lib/localize/index": 448,
	"./tr/_lib/localize/index.js": 448,
	"./tr/_lib/match": 449,
	"./tr/_lib/match/": 449,
	"./tr/_lib/match/index": 449,
	"./tr/_lib/match/index.js": 449,
	"./tr/index": 700,
	"./tr/index.d.ts": 1359,
	"./tr/index.js": 700,
	"./tr/index.js.flow": 1360,
	"./tr/package": 883,
	"./tr/package.json": 883,
	"./tr/snapshot.md": 1361,
	"./ug": 526,
	"./ug/": 526,
	"./ug/_lib/formatDistance": 450,
	"./ug/_lib/formatDistance/": 450,
	"./ug/_lib/formatDistance/index": 450,
	"./ug/_lib/formatDistance/index.js": 450,
	"./ug/_lib/formatLong": 451,
	"./ug/_lib/formatLong/": 451,
	"./ug/_lib/formatLong/index": 451,
	"./ug/_lib/formatLong/index.js": 451,
	"./ug/_lib/formatRelative": 452,
	"./ug/_lib/formatRelative/": 452,
	"./ug/_lib/formatRelative/index": 452,
	"./ug/_lib/formatRelative/index.js": 452,
	"./ug/_lib/localize": 453,
	"./ug/_lib/localize/": 453,
	"./ug/_lib/localize/index": 453,
	"./ug/_lib/localize/index.js": 453,
	"./ug/_lib/match": 454,
	"./ug/_lib/match/": 454,
	"./ug/_lib/match/index": 454,
	"./ug/_lib/match/index.js": 454,
	"./ug/index": 701,
	"./ug/index.d.ts": 1362,
	"./ug/index.js": 701,
	"./ug/index.js.flow": 1363,
	"./ug/package": 884,
	"./ug/package.json": 884,
	"./ug/snapshot.md": 1364,
	"./uk": 527,
	"./uk/": 527,
	"./uk/_lib/formatDistance": 455,
	"./uk/_lib/formatDistance/": 455,
	"./uk/_lib/formatDistance/index": 455,
	"./uk/_lib/formatDistance/index.js": 455,
	"./uk/_lib/formatLong": 456,
	"./uk/_lib/formatLong/": 456,
	"./uk/_lib/formatLong/index": 456,
	"./uk/_lib/formatLong/index.js": 456,
	"./uk/_lib/formatRelative": 457,
	"./uk/_lib/formatRelative/": 457,
	"./uk/_lib/formatRelative/index": 457,
	"./uk/_lib/formatRelative/index.js": 457,
	"./uk/_lib/localize": 458,
	"./uk/_lib/localize/": 458,
	"./uk/_lib/localize/index": 458,
	"./uk/_lib/localize/index.js": 458,
	"./uk/_lib/match": 459,
	"./uk/_lib/match/": 459,
	"./uk/_lib/match/index": 459,
	"./uk/_lib/match/index.js": 459,
	"./uk/index": 702,
	"./uk/index.d.ts": 1365,
	"./uk/index.js": 702,
	"./uk/index.js.flow": 1366,
	"./uk/package": 885,
	"./uk/package.json": 885,
	"./uk/snapshot.md": 1367,
	"./uz": 528,
	"./uz/": 528,
	"./uz/_lib/formatDistance": 460,
	"./uz/_lib/formatDistance/": 460,
	"./uz/_lib/formatDistance/index": 460,
	"./uz/_lib/formatDistance/index.js": 460,
	"./uz/_lib/formatLong": 461,
	"./uz/_lib/formatLong/": 461,
	"./uz/_lib/formatLong/index": 461,
	"./uz/_lib/formatLong/index.js": 461,
	"./uz/_lib/formatRelative": 462,
	"./uz/_lib/formatRelative/": 462,
	"./uz/_lib/formatRelative/index": 462,
	"./uz/_lib/formatRelative/index.js": 462,
	"./uz/_lib/localize": 463,
	"./uz/_lib/localize/": 463,
	"./uz/_lib/localize/index": 463,
	"./uz/_lib/localize/index.js": 463,
	"./uz/_lib/match": 464,
	"./uz/_lib/match/": 464,
	"./uz/_lib/match/index": 464,
	"./uz/_lib/match/index.js": 464,
	"./uz/index": 703,
	"./uz/index.d.ts": 1368,
	"./uz/index.js": 703,
	"./uz/index.js.flow": 1369,
	"./uz/package": 886,
	"./uz/package.json": 886,
	"./uz/snapshot.md": 1370,
	"./vi": 529,
	"./vi/": 529,
	"./vi/_lib/formatDistance": 465,
	"./vi/_lib/formatDistance/": 465,
	"./vi/_lib/formatDistance/index": 465,
	"./vi/_lib/formatDistance/index.js": 465,
	"./vi/_lib/formatLong": 466,
	"./vi/_lib/formatLong/": 466,
	"./vi/_lib/formatLong/index": 466,
	"./vi/_lib/formatLong/index.js": 466,
	"./vi/_lib/formatRelative": 467,
	"./vi/_lib/formatRelative/": 467,
	"./vi/_lib/formatRelative/index": 467,
	"./vi/_lib/formatRelative/index.js": 467,
	"./vi/_lib/localize": 468,
	"./vi/_lib/localize/": 468,
	"./vi/_lib/localize/index": 468,
	"./vi/_lib/localize/index.js": 468,
	"./vi/_lib/match": 469,
	"./vi/_lib/match/": 469,
	"./vi/_lib/match/index": 469,
	"./vi/_lib/match/index.js": 469,
	"./vi/index": 704,
	"./vi/index.d.ts": 1371,
	"./vi/index.js": 704,
	"./vi/index.js.flow": 1372,
	"./vi/package": 887,
	"./vi/package.json": 887,
	"./vi/snapshot.md": 1373,
	"./zh-CN": 55,
	"./zh-CN/": 55,
	"./zh-CN/_lib/formatDistance": 470,
	"./zh-CN/_lib/formatDistance/": 470,
	"./zh-CN/_lib/formatDistance/index": 470,
	"./zh-CN/_lib/formatDistance/index.js": 470,
	"./zh-CN/_lib/formatLong": 471,
	"./zh-CN/_lib/formatLong/": 471,
	"./zh-CN/_lib/formatLong/index": 471,
	"./zh-CN/_lib/formatLong/index.js": 471,
	"./zh-CN/_lib/formatRelative": 472,
	"./zh-CN/_lib/formatRelative/": 472,
	"./zh-CN/_lib/formatRelative/index": 472,
	"./zh-CN/_lib/formatRelative/index.js": 472,
	"./zh-CN/_lib/localize": 473,
	"./zh-CN/_lib/localize/": 473,
	"./zh-CN/_lib/localize/index": 473,
	"./zh-CN/_lib/localize/index.js": 473,
	"./zh-CN/_lib/match": 474,
	"./zh-CN/_lib/match/": 474,
	"./zh-CN/_lib/match/index": 474,
	"./zh-CN/_lib/match/index.js": 474,
	"./zh-CN/index": 705,
	"./zh-CN/index.d.ts": 1374,
	"./zh-CN/index.js": 705,
	"./zh-CN/index.js.flow": 1375,
	"./zh-CN/package": 888,
	"./zh-CN/package.json": 888,
	"./zh-CN/snapshot.md": 1376,
	"./zh-TW": 530,
	"./zh-TW/": 530,
	"./zh-TW/_lib/formatDistance": 475,
	"./zh-TW/_lib/formatDistance/": 475,
	"./zh-TW/_lib/formatDistance/index": 475,
	"./zh-TW/_lib/formatDistance/index.js": 475,
	"./zh-TW/_lib/formatLong": 476,
	"./zh-TW/_lib/formatLong/": 476,
	"./zh-TW/_lib/formatLong/index": 476,
	"./zh-TW/_lib/formatLong/index.js": 476,
	"./zh-TW/_lib/formatRelative": 477,
	"./zh-TW/_lib/formatRelative/": 477,
	"./zh-TW/_lib/formatRelative/index": 477,
	"./zh-TW/_lib/formatRelative/index.js": 477,
	"./zh-TW/_lib/localize": 478,
	"./zh-TW/_lib/localize/": 478,
	"./zh-TW/_lib/localize/index": 478,
	"./zh-TW/_lib/localize/index.js": 478,
	"./zh-TW/_lib/match": 479,
	"./zh-TW/_lib/match/": 479,
	"./zh-TW/_lib/match/index": 479,
	"./zh-TW/_lib/match/index.js": 479,
	"./zh-TW/index": 706,
	"./zh-TW/index.d.ts": 1377,
	"./zh-TW/index.js": 706,
	"./zh-TW/index.js.flow": 1378,
	"./zh-TW/package": 889,
	"./zh-TW/package.json": 889,
	"./zh-TW/snapshot.md": 1379
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 158;